export default __webpack_public_path__ + "static/media/blaze-menu-preview.34a8b929.mp4";